


import { Injectable } from '@angular/core';
import { ApiService } from '../core/api.service';

@Injectable()
export class BuroService {

  constructor(private apiService: ApiService){}

  verification(payload: any){
    return this.apiService.send('buro/reporteCreditoScore', payload)
      .then(data => {
        return data;
      })
      .catch(error => {
        console.error(error);
      })
  }
}



// WEBPACK FOOTER //
// ./src/app/core/service/app/buro.service.ts